import { useGlobalAuth } from '@headbox-ui/auth-hook'
import { FC, ReactNode, useEffect } from 'react'
import { LOGIN_SERVICE } from '../../Constants'
import MetaTitle from '../UI/MetaTitle'
import * as Sentry from '@sentry/browser'
import Spinner from '../Spinner/Spinner'

type AuthenticatorProps = {
  children: ReactNode
} & (
  | {
      requireAuth: false
      redirectToLogin?: false
      guestComponent?: undefined
    }
  | {
      requireAuth: true
      redirectToLogin: true
      guestComponent?: undefined
    }
  | {
      requireAuth: true
      redirectToLogin?: false
      guestComponent: ReactNode
    }
)
const Authenticator: FC<AuthenticatorProps> = ({
  children,
  requireAuth,
  redirectToLogin,
  guestComponent,
}) => {
  const { loading, authenticated, user } = useGlobalAuth()

  useEffect(() => {
    if (user) {
      Sentry.configureScope((scope) => {
        scope.setUser({
          id: `${user.id}`,
          email: user.email,
          name: user.firstName + ' ' + user.lastName,
        })
      })
    }
  }, [user])

  if (loading) {
    return (
      <>
        <MetaTitle title={'HeadBox'} />
        <Spinner fullScreen={true} />
      </>
    )
  }
  // conditional logic:
  // const isHost = HOST_ROLES.some((role) => user && user.roles.includes(role))
  // if (isHost &&
  if ((authenticated && Boolean(user)) || !requireAuth) {
    return <>{children}</>
  }
  if (redirectToLogin) {
    window.location.replace(LOGIN_SERVICE)
    return null
  }

  return <>{guestComponent}</>
}

export default Authenticator
